import { useEffect, useState } from 'react';
import * as _ from 'lodash';

export interface ResponsiveState {
  desktop: boolean;
  tablet: boolean;
}

const DESKTOP = 1000;
const TABLET = 900;

const computeState = (): ResponsiveState => {
  let w = window.innerWidth;
  return {
    desktop: w >= DESKTOP,
    tablet: w >= TABLET
  };
};

export const useResponsive = () => {
  const [state, setState] = useState<ResponsiveState>(() => {
    return computeState();
  });

  useEffect(() => {
    let cb = () => {
      let newState = computeState();
      if (!_.isEqual(state, newState)) {
        setState(computeState());
      }
    };
    window.addEventListener('resize', cb);
    return () => {
      window.removeEventListener('resize', cb);
    };
  }, [state]);

  return state;
};
